// Local development defaults. angular.json selects production and test replacements explicitly.
export const environment = {
  production: false,
  apiBaseUrl: 'https://admin.medclass.com.mx/api',
  baseUrl: 'https://admin.medclass.com.mx',
  frontUrl: 'https://medclass.nmn.mx',
  testLoginBaseUrl: 'https://medclass.nmn.mx',
  meduOrigin: 'https://medu.ai',
  idContenidoEspecial: '6a32f5aaa5dca4684b8a17b5',
  shortsEnabled: false,
  TOKEN_CIMA: 'bus|1781026053960x962749432992325600|1787644767108x675393400819780400',
  TOKEN_REPRESENTANTE: 'bus|1762266797195x941267978102780200|1787645744162x809829492232694900',
  TOKEN_MEDICO: 'bus|1698791918009x702627796604075500|1787645830407x484297145785680640'
};
